export let errorReporter = (_: string) => {
  // default nothing, a hook slot for biz to override
};

export const registerFGOnErrorHook = (hook: (errorContent: string) => void) => {
  errorReporter = hook;
};
